var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5052_2383",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5052_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 18.8333C3.70833 18.8333 3.31597 18.6701 2.98958 18.3437C2.66319 18.0173 2.5 17.625 2.5 17.1666V7.16665C2.5 6.70831 2.66319 6.31595 2.98958 5.98956C3.31597 5.66317 3.70833 5.49998 4.16667 5.49998H5.83333C5.83333 4.3472 6.23958 3.36456 7.05208 2.55206C7.86458 1.73956 8.84722 1.33331 10 1.33331C11.1528 1.33331 12.1354 1.73956 12.9479 2.55206C13.7604 3.36456 14.1667 4.3472 14.1667 5.49998H15.8333C16.2917 5.49998 16.684 5.66317 17.0104 5.98956C17.3368 6.31595 17.5 6.70831 17.5 7.16665V17.1666C17.5 17.625 17.3368 18.0173 17.0104 18.3437C16.684 18.6701 16.2917 18.8333 15.8333 18.8333H4.16667ZM4.16667 17.1666H15.8333V7.16665H4.16667V17.1666ZM10 12.1666C11.1528 12.1666 12.1354 11.7604 12.9479 10.9479C13.7604 10.1354 14.1667 9.15276 14.1667 7.99998H12.5C12.5 8.69442 12.2569 9.2847 11.7708 9.77081C11.2847 10.2569 10.6944 10.5 10 10.5C9.30556 10.5 8.71528 10.2569 8.22917 9.77081C7.74306 9.2847 7.5 8.69442 7.5 7.99998H5.83333C5.83333 9.15276 6.23958 10.1354 7.05208 10.9479C7.86458 11.7604 8.84722 12.1666 10 12.1666ZM7.5 5.49998H12.5C12.5 4.80554 12.2569 4.21526 11.7708 3.72915C11.2847 3.24304 10.6944 2.99998 10 2.99998C9.30556 2.99998 8.71528 3.24304 8.22917 3.72915C7.74306 4.21526 7.5 4.80554 7.5 5.49998Z",
    fill: "#47484C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.0317fdf38cf40f106cc2eb606001ec67.svg";
export { ForwardRef as ReactComponent };